import { render, staticRenderFns } from "./QuantityToTakeDownModal.vue?vue&type=template&id=2d273d5e&scoped=true&"
import script from "./QuantityToTakeDownModal.vue?vue&type=script&lang=js&"
export * from "./QuantityToTakeDownModal.vue?vue&type=script&lang=js&"
import style0 from "./QuantityToTakeDownModal.vue?vue&type=style&index=0&id=2d273d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d273d5e",
  null
  
)

export default component.exports